module.exports = __webpack_public_path__ + "img/briefcase.e1487a37.svg";